import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { VideoCard } from "@/components/VideoCard";
import { Loader2, Clapperboard, Upload } from "lucide-react";

export default function MyVideos() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/videos");
      setVideos(data);
    } catch (_) {} finally { setLoading(false); }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, [load]);

  return (
    <div className="space-y-6" data-testid="my-videos-page">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-700">Library</p>
          <h1 className="font-heading text-3xl sm:text-4xl font-semibold text-stone-900 mt-1">My Videos</h1>
        </div>
        <Link to="/mr/upload" className="inline-flex items-center gap-2 rounded-md bg-emerald-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-emerald-700">
          <Upload className="h-4 w-4" /> New
        </Link>
      </div>

      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="h-7 w-7 animate-spin text-emerald-600" /></div>
      ) : videos.length === 0 ? (
        <div className="rounded-lg border border-stone-200 bg-white p-12 text-center">
          <Clapperboard className="h-10 w-10 mx-auto text-stone-300" />
          <p className="mt-3 text-stone-600 font-medium">No videos yet</p>
          <p className="text-sm text-stone-400">Upload a doctor&apos;s greeting to get started.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {videos.map((v) => (
            <VideoCard key={v.id} video={v} onChanged={load} onDeleted={(id) => setVideos((p) => p.filter((x) => x.id !== id))} />
          ))}
        </div>
      )}
    </div>
  );
}
